// import React, { useRef, useState } from "react";
// import SignaturePad from "react-signature-canvas";

// const initialState = {
//   fullName: "",
//   address: "",
//   postcode: "",
//   contactNumber: "",
//   dateOfBirth: "",
//   conditions: {
//     heart: false,
//     seizures: false,
//     blood: false,
//     hiv: false,
//     hepatitis: false,
//     diabetes: false,
//     pressure: false,
//     skin: false,
//     allergies: false,
//     bloodMeds: false,
//     pregnant: false,
//   },
//   otherConditions: "",
//   agreementConfirmed: false,
//   signature: "",
// };

// const TattooConsentForm = () => {
//   const [formData, setFormData] = useState(initialState);
//   const [statusMessage, setStatusMessage] = useState(null);
//   const [messageType, setMessageType] = useState(null);
//   const sigPad = useRef(null);

//   const handleChange = (e) => {
//     const { name, value, type, checked } = e.target;

//     if (name in formData.conditions) {
//       setFormData((prev) => ({
//         ...prev,
//         conditions: {
//           ...prev.conditions,
//           [name]: checked,
//         },
//       }));
//     } else {
//       setFormData((prev) => ({
//         ...prev,
//         [name]: type === "checkbox" ? checked : value,
//       }));
//     }
//   };

//   const handleClear = () => {
//     sigPad.current.clear();
//     setFormData((prev) => ({ ...prev, signature: "" }));
//   };

//   const handleEndSignature = () => {
//     const signatureData = sigPad.current.getCanvas().toDataURL("image/png");
//     setFormData((prev) => ({ ...prev, signature: signatureData }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     const payload = {
//       ...formData,
//       dateSigned: new Date().toISOString(),
//     };

//     try {
//       const response = await fetch("http://localhost:5001/api/consent", {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(payload),
//       });

//       if (response.ok) {
//         setStatusMessage("Form submitted successfully!");
//         setMessageType("success");
//         setFormData(initialState);
//         sigPad.current?.clear();
//       } else {
//         setStatusMessage("Failed to submit form");
//         setMessageType("error");
//       }
//     } catch (err) {
//       console.error("Error submitting form:", err);
//       setStatusMessage("Error submitting form");
//       setMessageType("error");
//     }

//     setTimeout(() => {
//       setStatusMessage(null);
//       setMessageType(null);
//     }, 5000);
//   };

//   return (
//     <>
//       {statusMessage && (
//       <div className="floating-message-container">
//         <div
//           className={`p-4 rounded shadow-md text-white mb-4 floating-message ${
//             messageType === "success" ? "bg-green-500" : "bg-red-500"
//           }`}
//         >
//           {statusMessage}
//         </div>
//       </div>
//       )}
//       <form
//         onSubmit={handleSubmit}
//         className="max-w-2xl mx-auto p-6 bg-black rounded-xl shadow-md space-y-6 pt-[120px]"
//       >
//         <h2 className="text-2xl text-white font-bold">Tattoo Consent Form</h2>
//         <p className="text-white mt-0 text-xl">with <br /> Greg Cameron</p>
//         <p className="text-white mt-0 font-semibold">@throttledink</p>
//         <p className="text-white mb-4">Collective Tattoo, Derby <br /> 12 Market Place, DE1 3QE</p>
//         <p>Full Name</p>
//         <input
//           name="fullName"
//           value={formData.fullName}
//           onChange={handleChange}
//           placeholder="First Last"
//           className="w-full p-2 border rounded"
//           required
//         />
//         <p>Full Address</p>
//         <input
//           name="address"
//           value={formData.address}
//           onChange={handleChange}
//           placeholder="123 Street Name, City"
//           className="w-full p-2 border rounded"
//           required
//         />
//         <p>Post Code</p>
//         <input
//           name="postcode"
//           value={formData.postcode}
//           onChange={handleChange}
//           placeholder="P05T C0D3"
//           className="w-full p-2 border rounded"
//           required
//         />
//         <p>Contact Number</p>
//         <input
//           name="contactNumber"
//           value={formData.contactNumber}
//           onChange={handleChange}
//           placeholder="07900 123456"
//           className="w-full p-2 border rounded"
//           required
//           type="number"
//         />
//         <p>Date of Birth</p>
//         <input
//           name="dateOfBirth"
//           value={formData.dateOfBirth}
//           onChange={handleChange}
//           placeholder="Date of Birth"
//           type="date"
//           className="w-full p-2 border rounded"
//           required
//         />

//         <div className="mt-4">
//           <p className="font-semibold text-white mb-2">
//             Do you suffer from or have a diagnosis of any of the following?
//           </p>
//           {Object.entries(formData.conditions).map(([key, value]) => (
//             <label key={key} className="block text-white">
//               <input
//                 type="checkbox"
//                 name={key}
//                 checked={value}
//                 onChange={handleChange}
//                 className="mr-2 text-white"
//               />
//               {key
//                 .replace(/([A-Z])/g, " $1")
//                 .replace(/^./, (str) => str.toUpperCase())
//                 .replace("Meds", "Medication e.g. Aspirin")
//                 .replace("Blood", "Blood Disorders e.g. Hemophilia")
//                 .replace("Seizures", "Seizures e.g. Epilepsy")}
//             </label>
//           ))}
//           <textarea
//             name="otherConditions"
//             value={formData.otherConditions}
//             onChange={handleChange}
//             placeholder="Other health issues (if any)..."
//             className="w-full p-2 mt-2 border rounded"
//           />
//         </div>

//         <div className="space-y-2 text-sm text-white">
//           <p>I understand that a tattoo is permanent.</p>
//           <p>
//             I understand that no anaesthetic will be available during the
//             tattooing procedure.
//           </p>
//           <p>
//             I understand that every care will be taken to ensure the procedure
//             is hygienic.
//           </p>
//           <p>
//             I understand that once I leave the studio, I take full
//             responsibility for aftercare.
//           </p>
//           <p>
//             Risks include allergic reactions, swelling, scarring, septicaemia.
//           </p>
//           <p>I am over 18 years old (Tattooing of Minors Act 1969).</p>
//           <p>I am not under the influence of drugs or alcohol.</p>
//           <p>I have requested the tattoo of my own free will.</p>
//           <p>I am of sound body and mind.</p>
//         </div>

//         <label className="block mt-4 text-white">
//           <input
//             type="checkbox"
//             name="agreementConfirmed"
//             checked={formData.agreementConfirmed}
//             onChange={handleChange}
//             className="mr-2"
//           />
//           I agree and understand all of the above
//         </label>

//         <div className="mt-4">
//           <p className="mb-2">Signature</p>
//           <SignaturePad
//             ref={sigPad}
//             canvasProps={{ className: "border w-full h-32", style: { backgroundColor: "white" } }}
//             onEnd={handleEndSignature}
//           />
//           <button
//             type="button"
//             onClick={handleClear}
//             className="mt-2 text-sm text-white hover:underline"
//           >
//             Clear Signature
//           </button>
//         </div>

//         <button
//           type="submit"
//           className="bg-white text-black px-4 py-2 rounded hover:bg-gray-300"
//         >
//           Submit Consent Form
//         </button>
//       </form>
//     </>
//   );
// };

// export default TattooConsentForm;

import React, { useRef, useState, useEffect } from "react";
import SignaturePad from "react-signature-canvas";

const initialState = {
  fullName: "",
  address: "",
  postcode: "",
  contactNumber: "",
  dateOfBirth: "",
  conditions: {
    heart: false,
    seizures: false,
    blood: false,
    hiv: false,
    hepatitis: false,
    diabetes: false,
    pressure: false,
    skin: false,
    allergies: false,
    bloodMeds: false,
    pregnant: false,
  },
  otherConditions: "",
  agreementConfirmed: false,
  signature: "",
};

const TattooConsentForm = () => {
  // 🔒 Password protection state
  const [authenticated, setAuthenticated] = useState(false);
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const [formData, setFormData] = useState(initialState);
  const [statusMessage, setStatusMessage] = useState(null);
  const [messageType, setMessageType] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const sigPad = useRef(null);

  useEffect(() => {
    const isAuthed = sessionStorage.getItem("consentAuth");
    if (isAuthed === "true") setAuthenticated(true);
  }, []);

  useEffect(() => {
    if (!statusMessage) return;

    const timeoutId = setTimeout(() => {
      setStatusMessage(null);
      setMessageType(null);
    }, 5000);

    return () => clearTimeout(timeoutId);
  }, [statusMessage]);

  const handleAccess = (e) => {
    e.preventDefault();
    if (password === process.env.REACT_APP_CONSENT_PASSWORD) {
      setAuthenticated(true);
      sessionStorage.setItem("consentAuth", "true");
    } else {
      setError("Incorrect password");
    }
  };

  // ✍️ Form logic stays the same (unchanged)
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (name in formData.conditions) {
      setFormData((prev) => ({
        ...prev,
        conditions: {
          ...prev.conditions,
          [name]: checked,
        },
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: type === "checkbox" ? checked : value,
      }));
    }
  };

  const handleClear = () => {
    sigPad.current.clear();
    setFormData((prev) => ({ ...prev, signature: "" }));
  };

  const handleEndSignature = () => {
    const signatureData = sigPad.current.getCanvas().toDataURL("image/png");
    setFormData((prev) => ({ ...prev, signature: signatureData }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatusMessage(null);
    setMessageType(null);

    const requiredFields = [
      "fullName",
      "address",
      "postcode",
      "contactNumber",
      "dateOfBirth",
      "signature",
    ];
    const missingRequired = requiredFields.some((field) => {
      const value = formData[field];
      return typeof value === "string" ? value.trim() === "" : !value;
    });

    if (missingRequired) {
      setStatusMessage(
        "Please complete all required fields, including signature."
      );
      setMessageType("error");
      return;
    }

    setIsSubmitting(true);

    const payload = {
      ...formData,
      dateSigned: new Date().toISOString(),
    };

    try {
      const response = await fetch("/.netlify/functions/submitConsent", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      if (response.ok) {
        setStatusMessage("Form submitted successfully!");
        setMessageType("success");
        setFormData(initialState);
        sigPad.current?.clear();
      } else {
        setStatusMessage("Failed to submit form");
        setMessageType("error");
      }
    } catch (err) {
      console.error("Error submitting form:", err);
      setStatusMessage("Error submitting form");
      setMessageType("error");
    } finally {
      setIsSubmitting(false);
    }

  };

  // 🧱 Password gate screen (with fade-in animation)
  if (!authenticated) {
    return (
      <section
        className="min-h-screen flex flex-col justify-center items-center bg-black text-white px-4
        opacity-0 animate-fadeIn"
      >
        <form
          onSubmit={handleAccess}
          className="p-8 w-full max-w-md text-center"
        >
          <h2 className="text-2xl mb-6 font-semibold tracking-wide uppercase text-chrome">
            Enter Access Code
          </h2>

          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Access code"
            className="w-full px-4 py-3 rounded bg-black border border-gray-700 text-white text-center
              focus:outline-none focus:ring-2 focus:ring-chrome focus:border-chrome border"
          />

          {error && <p className="text-red-500 mt-3">{error}</p>}

          <button
            type="submit"
            className="mt-6 bg-white text-black font-semibold px-8 py-3 rounded hover:bg-gray-300 transition uppercase tracking-wide"
          >
            Enter
          </button>
        </form>

        <p className="text-gray-600 mt-12 text-sm">Secure Client Form</p>
      </section>
    );
  }

  // 🎯 Main consent form (unchanged)
  return (
    <>
      {isSubmitting && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70">
          <div className="flex flex-col items-center gap-4 text-white">
            <div className="h-12 w-12 animate-spin rounded-full border-4 border-white/40 border-t-white" />
            <span className="text-xs uppercase tracking-[0.25em]">
              Submitting
            </span>
          </div>
        </div>
      )}

      {statusMessage && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 px-6">
          <div
            className={`relative w-full max-w-md rounded-xl border px-6 py-5 text-center text-white shadow-2xl ${
              messageType === "success"
                ? "bg-green-600/90 border-green-300"
                : "bg-red-600/90 border-red-300"
            }`}
          >
            <button
              type="button"
              onClick={() => {
                setStatusMessage(null);
                setMessageType(null);
              }}
              className="absolute right-3 top-3 text-white/70 hover:text-white"
              aria-label="Close message"
            >
              ✕
            </button>
            <p className="text-lg font-semibold">{statusMessage}</p>
            <p className="mt-2 text-sm text-white/80">
              {messageType === "success"
                ? "Thanks, your consent has been recorded."
                : "Please try again or check your connection."}
            </p>
          </div>
        </div>
      )}

      <form
        onSubmit={handleSubmit}
        className="max-w-2xl mx-auto p-6 bg-black rounded-xl shadow-md space-y-6 pt-[120px]"
      >
        <h2 className="text-2xl text-white font-bold">Tattoo Consent Form</h2>
        <p className="text-white mt-0 text-xl">
          with <br /> Greg Cameron
        </p>
        <p className="text-white mt-0 font-semibold">@throttledink</p>
        <p className="text-white mb-4">
          Collective Tattoo, Derby <br /> 12 Market Place, DE1 3QE
        </p>
        <p>Full Name</p>
        <input
          name="fullName"
          value={formData.fullName}
          onChange={handleChange}
          placeholder="First Last"
          className="w-full p-2 border rounded"
          required
        />
        <p>Full Address</p>
        <input
          name="address"
          value={formData.address}
          onChange={handleChange}
          placeholder="123 Street Name, City"
          className="w-full p-2 border rounded"
          required
        />
        <p>Post Code</p>
        <input
          name="postcode"
          value={formData.postcode}
          onChange={handleChange}
          placeholder="P05T C0D3"
          className="w-full p-2 border rounded"
          required
        />
        <p>Contact Number</p>
        <input
          name="contactNumber"
          value={formData.contactNumber}
          onChange={handleChange}
          placeholder="07900 123456"
          className="w-full p-2 border rounded"
          required
          type="number"
        />
        <p>Date of Birth</p>
        <input
          name="dateOfBirth"
          value={formData.dateOfBirth}
          onChange={handleChange}
          placeholder="Date of Birth"
          type="date"
          className="w-full p-2 border rounded"
          required
        />

        <div className="mt-4">
          <p className="font-semibold text-white mb-2">
            Do you suffer from or have a diagnosis of any of the following?
          </p>
          {Object.entries(formData.conditions).map(([key, value]) => (
            <label key={key} className="block text-white">
              <input
                type="checkbox"
                name={key}
                checked={value}
                onChange={handleChange}
                className="mr-2 text-white"
              />
              {key
                .replace(/([A-Z])/g, " $1")
                .replace(/^./, (str) => str.toUpperCase())
                .replace("Meds", "Medication e.g. Aspirin")
                .replace("Blood", "Blood Disorders e.g. Hemophilia")
                .replace("Seizures", "Seizures e.g. Epilepsy")
                .replace("Pressure", "High Blood Pressure")}
            </label>
          ))}
          <textarea
            name="otherConditions"
            value={formData.otherConditions}
            onChange={handleChange}
            placeholder="Other health issues (if any)..."
            className="w-full p-2 mt-2 border rounded"
          />
        </div>

        <div className="space-y-2 text-sm text-white">
          <p>I understand that a tattoo is permanent.</p>
          <p>
            I understand that no anaesthetic will be available during the
            tattooing procedure.
          </p>
          <p>
            I understand that every care will be taken to ensure the procedure
            is hygienic.
          </p>
          <p>
            I understand that once I leave the studio, I take full
            responsibility for aftercare.
          </p>
          <p>
            Risks include allergic reactions, swelling, scarring, septicaemia.
          </p>
          <p>I am over 18 years old (Tattooing of Minors Act 1969).</p>
          <p>I am not under the influence of drugs or alcohol.</p>
          <p>I have requested the tattoo of my own free will.</p>
          <p>I am of sound body and mind.</p>
        </div>

        <label className="block mt-4 text-white">
          <input
            type="checkbox"
            name="agreementConfirmed"
            checked={formData.agreementConfirmed}
            onChange={handleChange}
            className="mr-2"
          />
          I agree and understand all of the above
        </label>

        <div className="mt-4">
          <p className="mb-2">Signature</p>
          <SignaturePad
            ref={sigPad}
            canvasProps={{
              className: "border w-full h-32",
              style: { backgroundColor: "white" },
            }}
            onEnd={handleEndSignature}
          />
          <button
            type="button"
            onClick={handleClear}
            className="mt-2 text-sm text-white hover:underline"
          >
            Clear Signature
          </button>
        </div>

        <button
          type="submit"
          disabled={isSubmitting}
          className="bg-white text-black px-4 py-2 rounded hover:bg-gray-300 disabled:cursor-not-allowed disabled:opacity-60"
        >
          Submit Consent Form
        </button>
      </form>
    </>
  );
};

export default TattooConsentForm;
